<template>
  <div class="form-group" v-bind:class="{'disabled': parseBoolean(disabled)}">
    <label v-bind:for="id" v-if="label" class="form-label">{{ label }}
      <i v-if="parseBoolean(required)" class="far fa-asterisk"></i>
      <span v-if="language" class="language"> ({{ language }})</span>
    </label>
    <div class="input-group d-flex">
      <span class="input-group-text flex-grow-0">+</span>
      <input v-bind:id="callingCodeId"
             ref="input"
             type="text"
             v-model="internalCallingCode"
             v-bind:placeholder="callingCodePlaceholder"
             maxlength="4"
             size="4"
             class="form-control flex-grow-0"
             v-bind:class="{'is-invalid': invalid}"
             v-bind:disabled="parseBoolean(disabled)"/>
      <input v-bind:id="phoneId"
             ref="input"
             type="text"
             v-model="internalPhone"
             v-bind:placeholder="phonePlaceholder"
             maxlength="25"
             class="form-control flex-grow-1"
             v-bind:class="{'is-invalid': invalid}"
             v-bind:disabled="parseBoolean(disabled)"/>
    </div>
    <local-errors v-bind:value="errors"/>
    <div v-if="help" class="form-text">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "input-calling-code-and-phone",
  props: ["id", "value", "errors", "label", "callingCodePlaceholder", "phonePlaceholder", "language", "required", "disabled"],
  computed: {
    callingCodeId: function () {
      return this.id + ":calling-code";
    },
    phoneId: function () {
      return this.id + ":phone";
    },
    help: function () {
      return !!this.$slots.default;
    },
    invalid: function () {
      return this.errors && this.errors.length > 0;
    },
    internalCallingCode: {
      get: function () {
        return this.value ? this.value.callingCode : null;
      },
      set: function (newValue) {
        this.$emit("input", {
          callingCode: newValue,
          phone: this.internalPhone
        });
      }
    },
    internalPhone: {
      get: function () {
        return this.value ? this.value.phone : null;
      },
      set: function (newValue) {
        this.$emit("input", {
          callingCode: this.internalCallingCode,
          phone: newValue
        });
      }
    }
  }
}
</script>
